(function() {
    angular
        .module("devicesModule")
        .controller("DeviceTrackerHistoryAlertsController", DeviceTrackerHistoryAlertsController)

    DeviceTrackerHistoryAlertsController.$inject = [
        "$rootScope",
        "$scope"
    ]

    function DeviceTrackerHistoryAlertsController(
        $rootScope,
        $scope
    ){
        "use strict"

        $rootScope.historySortTitle = "Alerts"
        $rootScope.historyType = "alerts"
        $rootScope.alertHistory = []
        $rootScope.page = 1

        $scope.getData()

        $scope.getDeviceHistory = (startDate, endDate) => {
            $scope.changeStartDate(startDate)
            $scope.changeEndDate(endDate)
            $rootScope.minDate = startDate
            $rootScope.maxDate = endDate
            $scope.minDateOptions.maxDate = endDate
            $scope.maxDateOptions.minDate = startDate

            $scope.getData()

        }

        $scope.minStatus = {
            opened: false
        }
        $scope.maxStatus = {
            opened: false
        }

        $scope.today = () => {
            $scope.dt = new Date()
        }
        $scope.today()

        $scope.dtMin = $rootScope.minDate
        $scope.dtMax = $rootScope.maxDate || new Date()

        $scope.clear = () => {
            $scope.dt = null
        }

        $scope.openMin = () => {
            $scope.minStatus.opened = true
        }

        $scope.openMax = () => {
            $scope.maxStatus.opened = true
        }

        $scope.minDateOptions = {
            formatYear: "yy",
            startingDay: 1,
            showWeeks: false,
            maxDate: $scope.dtMax
        }

        $scope.maxDateOptions = {
            formatYear: "yy",
            startingDay: 1,
            showWeeks: false,
            minDate: $scope.dtMin
        }

        $scope.format = "MM/dd/yyyy"

    }
})()
